import type { OptionalTableHeaderParam } from '../pprTypes.ts';

export const optionalTableHeaderParams: OptionalTableHeaderParam[] = [
	'showCreator',
	'showLastModified',
	'showPageLabels',
	'showCommentsCount',
	'showUnresolvedCommentsCount',
	'showLikesCount',
];

export const DEFAULT_MAX_PAGE_SIZE = 30;
export const MAX_PDF_PAGE_SIZE = 500;
